/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const RestoreOptions = core.serialization.object({
    created: core.serialization.boolean(),
    updated: core.serialization.boolean(),
    deleted: core.serialization.boolean(),
});
